import React from "react";
import { FC } from "react";
import { TFunction } from "i18next";
import { useSeo } from "../../shared/components/UseSeoComponent";
import "./style.css";

interface ExperiencePageProps {
  maxWidth: number;
  screenWidth: number;
  screenHeight: number;
  t: TFunction<"translation", undefined>;
}

const ExperiencePage: FC<ExperiencePageProps> = (
  props: ExperiencePageProps
) => {
  const { t, maxWidth, screenWidth, screenHeight } = props;

  // Use SEO hook
  useSeo("experiencePage");

  return (
    <>
      <div className="container-fluid pb-5 mt-5 d-flex flex-column align-items-center justify-content-center">
        <div className="experience-page">
          <div className="container">
            <div className="row">
              <div className="col-12 mb-5">
                <h1 className="about-title">{t("experiencePage.title")}</h1>
              </div>
            </div>

            <div className="row experience-content">
              <div className="col-12">
                <div className="experience-column">
                  <div className="experience-text">
                    {t("experiencePage.content")
                      .split("\n\n")
                      .map((paragraph: string, index: number) => (
                        <p key={index} className="experience-paragraph">
                          {paragraph}
                        </p>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExperiencePage;
